import styled from '@emotion/styled';
import { brandNeutralColors, colors } from 'ui_system/compass';
import { SubmitButton } from 'ui_system/forms/FormStyles';
import { Theme } from 'ui_system/theme';

export const AddGuestFormWrapper = styled.div`
  color: ${colors.text.primary};
  font-size: 16px;
  padding: 0 16px;
  text-align: left;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 20px 16px;
  }
`;

export const AddFormInput = styled.div`
  margin-bottom: 30px;
`;

export const Input = styled.input`
  color: ${colors.text.primary};
  background-color: white;
  border: 1px solid ${colors.borderAction};
  width: 100%;
  height: 44px;
  line-height: 42px;
  border-radius: 0px;
  padding: 0 10px;
  margin-left: 0;
  font-size: 14px;
  &:focus {
    outline: 0;
  }
`;

export const AddFormHeading = styled.div`
  font-size: 18px;
  text-align: center;
  margin: 0;
  font-weight: 600;
`;

export const TicketHeading = styled.div`
  font-size: 14px;
  text-align: center;
  margin: 0;
  font-weight: 400;
  color: ${colors.text.placeholder};
  font-family: 'soleil';
  margin-top: 10px;
`;

export const InputColumn = styled.div`
  display: inline-block;
  width: 48%;
  &:last-child {
    float: right;
  }
`;

export const Label = styled.div`
  font-family: 'soleil';
  display: block;
  font-weight: 400;
  margin-bottom: 6px;
  width: 100%;
`;

export const EmailInput = styled.div``;

export const Error = styled.div`
  background: ${colors.error};
  color: ${colors.white};
  font-size: 14px;
  margin-top: -1px;
  padding: 4px 8px;
  position: relative;
`;

export const Footer = styled.div`
  text-align: center;
  border-top: 1px solid ${brandNeutralColors.border};
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 0;
  padding-top: 40px;
`;

export const SaveButton = styled(SubmitButton)`
  width: 340px;
  height: 45px;
`;

export const DrowDown = styled.div`
  background-color: white;
  border: 1px solid ${colors.borderAction};
  width: 100%;
  height: 44px;
  line-height: 42px;
  border-radius: 0px;
  margin-left: 0;
  font-size: 14px;
  &:focus {
    outline: 0;
  }
`;

export const CapacityWarningWrapper = styled.div<{ isDropdownOpen: boolean }>`
  overflow: hidden;
  max-height: ${(props) => (props.isDropdownOpen ? 0 : '100px')};
  opacity: ${(props) => (props.isDropdownOpen ? 0 : 1)};
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
`;
